import { render, staticRenderFns } from "./ProjectInfoModal_comp.vue?vue&type=template&id=3a24fe9f&"
import script from "./ProjectInfoModal_comp.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoModal_comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports